// extracted by mini-css-extract-plugin
export default {"buttonGoogle":"style_buttonGoogle__om5l-"};